import { Alert } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { HolterDirectExaminationRequestData } from '@common/validation/customControls/cardiology/holter/holterDirectExaminationRequestSchemas';
import type { IReduxState } from '@frontend/configureStore';
import { DesktopProcessErrorCode } from '@common/enums/desktopProcessErrorCodes';
import { HardwareProcessStatus } from '@common/enums/hardwareProcessStatus';
import { useProcessActivityEditContext } from '@frontend/utils';
import { desktopProcessErrorCodeText } from '../utils/desktopProcessErrorCodeText';

export function HolterConfigureWarnings() {
    const {
        data: { hasDesktopProcessTimedOut, isMissingKsyosUrlHandler, processError, processStatus },
    } = useProcessActivityEditContext<HolterDirectExaminationRequestData>();
    const organizationId = useSelector((state: IReduxState) => state.authentication.organizationId);

    if (isMissingKsyosUrlHandler) {
        return (
            <Alert appearance="warning">
                De nieuwe Ksyos koppeling is nog niet geïnstalleerd,{' '}
                <a
                    href={`/desktop?organizationId=${organizationId}`}
                    rel="noreferrer"
                    target="_blank"
                >
                    download hem hier
                </a>{' '}
                .
            </Alert>
        );
    } else if (hasDesktopProcessTimedOut) {
        return (
            <Alert appearance="warning">
                Wij denken dat je de Ksyos koppeling nog niet hebt geïnstalleerd op deze computer.{' '}
                <a
                    href={`/desktop?organizationId=${organizationId}`}
                    rel="noreferrer"
                    target="_blank"
                >
                    Download deze hier
                </a>{' '}
                of neem contact op met onze Servicedesk.
            </Alert>
        );
    } else if (processStatus === HardwareProcessStatus.failed) {
        const recorderFailureMessage =
            'Er is wat mis met deze recorder, neem contact op met de Servicedesk dan zoeken we het voor je uit.';

        if (processError) {
            if (processError === DesktopProcessErrorCode.HOLTER_NOT_SET_BUT_CONTAINS_RECORDING) {
                return (
                    <Alert appearance="warning">
                        Deze recorder bevat een opname. Mogelijk is de recorder per ongeluk gestart. Je kan de recorder{' '}
                        <Alert.Link
                            to="/holter/dashboard"
                            variant="link"
                        >
                            op het recorderoverzicht
                        </Alert.Link>{' '}
                        leeg maken, zodat deze weer in te stellen is.
                    </Alert>
                );
            }

            const errorText = desktopProcessErrorCodeText[processError];

            return <Alert appearance="warning">{errorText ?? recorderFailureMessage}</Alert>;
        } else {
            return <Alert appearance="warning">{recorderFailureMessage}</Alert>;
        }
    }

    return null;
}
